import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const misp = defineConnector({
  identifier: "misp",
  name: "MISP",
  tagLine: "Open source threat intelligence platform",
  logo,
  protocol: "http",
  tags: ["security"],
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your MISP instance, go to **Global Actions > My Profile** and copy your **Authkey**. If you don’t have one, click **Add authentication key**.",
        },
      ],
    },
    {
      title: "Enter your MISP details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          placeholder: "https://misp.your-org.com",
          required: true,
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The URL of your MISP instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "Your MISP authentication key.",
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/servers/getVersion.json`,
  },
});
